import { Action } from '@ngrx/store';

export enum UsersOnlineActionTypes {
    Connect = '[App] Connect user success',
    Disconnect = '[App] Disconnect user success'
}

export class Connect implements Action {
    readonly type = UsersOnlineActionTypes.Connect;
    constructor(public userId: string) {}
}

export class Disconnect implements Action {
    readonly type = UsersOnlineActionTypes.Disconnect;
    constructor(public userId: string) {}
}

export type UsersOnlineActions = Connect | 
                         Disconnect;
